import {SyntheticEvent} from 'react';
import {twMerge} from '../../common/twMerge';
import {getSafeAreaPaddingClassName} from '../../domain/common/util/getSafeAreaClassName';
import {Icon} from '../atoms/Icon/Icon';
import {IconType} from '../atoms/Icon/IconType.enum';
import {Text} from '../atoms/Text/Text';

interface Props {
  headerTitle?: string;
  onClickBack: (e: SyntheticEvent) => void;
  hideBackButton?: boolean;
}

export function MobileLayoutGlobalAuthHeader({
  headerTitle,
  onClickBack,
  hideBackButton,
}: Props) {
  return (
    <div
      className={twMerge(
        'w-full bg-theme-bg-base-alt',
        getSafeAreaPaddingClassName('top')
      )}
    >
      <div className="flex h-mobile_header_height_px items-center pl-18pxr">
        {!hideBackButton && (
          <Icon
            onClick={onClickBack}
            alt="뒤로가기"
            className="mr-10pxr cursor-pointer"
            type={IconType.NavigationBack}
          />
        )}
        <Text className="font-medium1-bold text-theme-solid-100">
          {headerTitle}
        </Text>
      </div>
    </div>
  );
}
